import { render, staticRenderFns } from "./CollectionCustomer_mobile.vue?vue&type=template&id=023d3f38&scoped=true"
import script from "./CollectionCustomer_mobile.vue?vue&type=script&lang=js"
export * from "./CollectionCustomer_mobile.vue?vue&type=script&lang=js"
import style0 from "./CollectionCustomer_mobile.vue?vue&type=style&index=0&id=023d3f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d3f38",
  null
  
)

export default component.exports